import $ from 'jquery';
import {
	PROVINCE_BILL_INPUT,
	PROVINCE_SHIP_INPUT,
	STATE_BILL_SELECT,
	STATE_SHIP_SELECT,
	US_STATES,
	CA_STATES,
	AU_STATES,
	GB_STATES,
	WORLD_COUNTRIES,
} from './constants';
import {
	debug,
	handleFinishedOrderError,
	loadScript,
	getCountryEnv,
	lowerCaseAllWordsExceptFirstLetters,
	skipUpsell,
	getQueryParamValue,
} from './utils';
import {
	getConfig
} from './config';

var countriesWithStates = ["US", "CA", "AU", "GB"];

export function initCountries() {
	var intlCountrySetting = getConfig().countries;
	var intlCountrySettingBlacklist = getConfig().countriesExcept;
	if (!intlCountrySettingBlacklist) {
		intlCountrySettingBlacklist = "";
	}

	if (intlCountrySetting) {
	if (intlCountrySetting === 'all') {
		if ($('#cShipCountry').length) {
			setCountries("cShipCountry", "US", null, intlCountrySettingBlacklist.split(","));
		}
		if ($('#cBillCountry').length) {
			setCountries("cBillCountry", "US", null, intlCountrySettingBlacklist.split(","));
		}
	} else {
		if ($('#cShipCountry').length) {
			setCountries("cShipCountry", "US", intlCountrySetting.split(","), intlCountrySettingBlacklist.split(","));
		}
		if ($('#cBillCountry').length) {
			setCountries("cBillCountry", "US", intlCountrySetting.split(","), intlCountrySettingBlacklist.split(","));
		}
	}

	$('#cShipCountry').change(function() {
		stateShipChange();
		try {
			initTotalBox();
		} catch (e) {
			debug("Country change callback function \"initTotalBox\" not found");
		}
	});
	$('#cBillCountry').change(function() {
		stateBillChange();
	});
}
}

export function setStates(fieldID, preselect, country = "US") {
	switch (country) {
		case "US":
			var statesObject = US_STATES;
			break;
		case "CA":
			var statesObject = CA_STATES;
			break;
		case "AU":
			var statesObject = AU_STATES;
			break;
		case "GB":
			var statesObject = GB_STATES;
			break;
	}

	let optionLine = '<option value="">Please Select State</option>';
	$.each(statesObject, (i, e) => {
		optionLine += '<option ';
		if (e.abbreviation == preselect) {
			optionLine += 'selected';
		}
		optionLine += ` value="${e.abbreviation}">${lowerCaseAllWordsExceptFirstLetters(e.name)}</option>`;
	});

	if ($(`#${fieldID}`).prop('tagName') == 'SELECT') {
		$(`#${fieldID}`).html(optionLine);
	}
}

export function setCountries(fieldID, preselect, listOfCountries = NULL, listOfCountriesBlacklist = NULL) {
	let optionLine = '<option value="">Please Select Country</option>';
	$.each(WORLD_COUNTRIES, (i, e) => {
		if (listOfCountries && $.inArray(e.Code.toUpperCase(), listOfCountries) == -1) {
			return;
		}

		if (listOfCountriesBlacklist && $.inArray(e.Code.toUpperCase(), listOfCountriesBlacklist) != -1) {
			return;
		}

		if (e.Name) {
			optionLine += '<option ';
			if (e.Code === preselect) {
				optionLine += 'selected';
			}
			optionLine += ` value="${e.Code}">${e.Name}</option>`;
		} else {
			optionLine += '<option disabled></option>'; // group separator line
		}
	});
	$(`#${fieldID}`).html(optionLine);
}

export function setCustomerShipCountry(stateValue) {
	$("[name='cShipCountry']").find('option').each((index, element) => {
		if (element.value == stateValue) element.selected = 'selected';
	});
}

export function setCustomerBillCountry(stateValue) {
	$("[name='cBillCountry']").find('option').each((index, element) => {
		if (element.value == stateValue) element.selected = 'selected';
	});
}

export function setCustomerBillState(stateValue) {
	$("[name='cBillState']").find('option').each((index, element) => {
		if (element.value == stateValue) element.selected = 'selected';
	});
}

export function stateShipChange() {
	if ($.inArray($('select[name="cShipCountry"] option:selected').val(), countriesWithStates) != -1) {
		$('#cShipState').replaceWith(STATE_SHIP_SELECT);
		setStates("cShipState", "", $('select[name="cShipCountry"] option:selected').val())
	} else {
		$('#cShipState').replaceWith(PROVINCE_SHIP_INPUT);
	}
}

export function stateBillChange() {
	if ($.inArray($('select[name="cBillCountry"] option:selected').val(), countriesWithStates) != -1) {
		$('#cBillState').replaceWith(STATE_BILL_SELECT);
		setStates("cBillState", "", $('select[name="cBillCountry"] option:selected').val())
	} else {
		$('#cBillState').replaceWith(PROVINCE_BILL_INPUT);
	}
}

export function duplicateShippingIntoBilling() {
	$('input[name=cBillFName]').val($('input[name=cShipFName]').val());
	$('input[name=cBillLName]').val($('input[name=cShipLName]').val());
	$('input[name=cBillAddress1]').val($('input[name=cShipAddress1]').val());
	$('input[name=cBillAddress2]').val($('input[name=cShipAddress2]').val());
	$('input[name=cBillZip]').val($('input[name=cShipZip]').val());
	if ($('select[name=cShipCountry]').length) {
		const cSelection = $('select[name=cShipCountry]')[0].selectedIndex;
		$('select[name=cBillCountry] option').eq(cSelection).prop('selected', true);
	}

	if ($('select[name="cBillCountry"]').length) {
		stateBillChange();
	}

	var statesUpdateTimeout = setTimeout(function() {
		$('input[name=cBillCity]').val($('input[name=cShipCity]').val());

		if ($('[name=cShipState]').prop('tagName') == 'SELECT') {
			const sSelection = $('select[name=cShipState]')[0].selectedIndex;
			$('select[name=cBillState] option').eq(sSelection).prop('selected', true);
		} else {
			$('input[name=cBillState]').val($('input[name=cShipState]').val());
		}

		$('input[name="cBillZip"], input[name="cBillState"], input[name="cBillCity"]').blur();

	}, 1000);
}

// Query directly after the path: the API Gateway route 404s on
// '/get-shipping-zip/?zip='. '' when no lookup service is configured.
export function buildZipLookupUrl(zip) {
	const base = String(getConfig().zipDetectURL || '').trim().replace(/\/$/, '');
	if (!base) {
		return '';
	}
	return `${base}?zip=${zip}`;
}

function zipAutofillBasic() {
	/*
	  ZIP Autofill Script (Powered by USPS)
	  Possible params:
	  ----------------------------
	  zipFeedback = true/false -
	  to fill the static location data (#city-name and #state-name)
	  zipCityPlaceholder = "City" - to set a placeholder
	*/

	function beautifyCityName(cityName) {
		const spart = cityName.split(' ');
		for (let i = 0; i < spart.length; i += 1) {
			const j = spart[i].charAt(0).toUpperCase();
			spart[i] = j + spart[i].substr(1);
		}
		return spart.join(' ');
	}

	$(() => {
		// shipping section zip handling
		$('#cShipZip').keyup(function() {
			if ($(this).val().length >= 3 && !isNaN($(this).val()) && getCountryEnv("cShipCountry") === "US") {
				const zip = $(this).val();
				const zipElement = $(this);
				const USPSUrl = buildZipLookupUrl(zip);
				if (!USPSUrl) {
					return;
				}

				$.ajax({
					type: 'GET',
					url: USPSUrl,
					dataType: 'text',
					success(response) {
						const jqObj = $($.parseXML(response));
						let state = '';
						if (jqObj.find('Error').length === 0) { // There's a City for ZIP
							let city = jqObj.find('City').text().toLowerCase();
							state = jqObj.find('State').text();
							city = beautifyCityName(city); // Capitalize City Name
							$('#cShipCity').val('').removeClass('valid invalid').val(city);

							if (getConfig().zipFeedback === true) {
								$('#city-name').html(city);
							}
							zipElement.parents('form:first').validate().element('#cShipCity');
						} else { // ZIP Error or no Cities found
							$('#cShipCity').val('').addClass('invalid');
							const cityPlaceholder = getConfig().zipCityPlaceholder;
							$('#cShipCity').attr('placeholder', cityPlaceholder);
							if (getConfig().zipFeedback === true) {
								$('#city-name').html('');
							}
							zipElement.parents('form:first').validate().element('#cShipCity');
						}

						$('#cShipState').val(state);
						if (getConfig().zipFeedback === true) {
							$('#state-name').html($('#cShipState option:selected').val());
						}
						zipElement.parents('form:first').validate().element('#cShipState');
					},
					done() {},
				});
			} else { // just field init
				const cityPlaceholder = getConfig().zipCityPlaceholder;
				$('#cShipCity').attr('placeholder', cityPlaceholder);
			}
		});
		// shipping section zip handling

		// billing section zip handling
		$('#cBillZip').keyup(function() {
			if ($(this).val().length >= 3 && !isNaN($(this).val()) && getCountryEnv("cBillCountry") === "US") {
				const zip = $(this).val();
				const zipElement = $(this);
				const USPSUrl = buildZipLookupUrl(zip);
				if (!USPSUrl) {
					return;
				}

				$.ajax({
					type: 'GET',
					url: USPSUrl,
					dataType: 'text',
					success(response) {
						const jqObj = $($.parseXML(response));

						let state = '';
						if (jqObj.find('Error').length === 0) { // There's a City for ZIP
							let city = jqObj.find('City').text().toLowerCase();
							state = jqObj.find('State').text();
							city = beautifyCityName(city); // Capitalize City Name
							$('#cBillCity').val('').removeClass('valid invalid').val(city);
							zipElement.parents('form:first').validate().element('#cBillCity');
						} else { // ZIP Error or no Cities found
							$('#cBillCity').val('').addClass('invalid');
							const cityPlaceholder = getConfig().zipCityPlaceholder;
							$('#cBillCity').attr('placeholder', cityPlaceholder);
							zipElement.parents('form:first').validate().element('#cBillCity');
						}

						$('#cBillState').val(state);
						zipElement.parents('form:first').validate().element('#cBillState');
					},
					done() {},
				});
			} else { // just field init
				const cityPlaceholder = getConfig().zipCityPlaceholder;
				$('#cBillCity').attr('placeholder', cityPlaceholder);
			}
		});
		// billing section zip handling

		(function() {
			$('#cShipZip').keyup();
			$('#cShipZip').blur(() => {
				$('#cShipZip').keyup();
			});
		}());

		(function() {
			$('#cBillZip').keyup();
			$('#cBillZip').blur(() => {
				$('#cBillZip').keyup();
			});
		}());
	});
}

// ZIP autofill binding. The Google Places provider was removed in 1.2.3 (it
// hardcoded a Maps API key into the published bundle); the basic USPS lookup
// via `zipDetectURL` is the only provider.
export function initZipAutofill() {
	zipAutofillBasic();
}